import { render, staticRenderFns } from "./LancarNotasPage.vue?vue&type=template&id=6774c5f2"
import script from "./LancarNotasPage.vue?vue&type=script&lang=js"
export * from "./LancarNotasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports